import {connect} from '@modifi/redux'
import {compose} from 'ramda'
import {aPush} from '@modifi/router'
import {withSuspense} from '@modifi/plugin-onboarding'

import {FeInputFieldStatus} from '@modifi/enums'
import ExistingDirector from './ExistingDirector'
import {
  aInitializePage,
  aReset,
  aSavePage,
  selectInitialFormData,
  selectInitializePagePending,
  selectSaveErrorMessage,
  selectSaveHasError,
  selectSavePending,
} from '../store/form'
import {
  selectDirectorByExternalId,
  selectDirectorNameByExternalId,
} from '../../../../data/directors'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {SECTION_DIRECTORS} from '../../../../constants/sections'
import {selectIsAnyRoleBasedFieldsVisible} from '../store/selectors'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>, ownProps: Record<string, any>) => {
  const externalCompanyId = ownProps?.match?.params?.externalCompanyId
  const externalPersonId = ownProps?.match?.params?.externalId

  const isLoading = selectInitializePagePending(state, externalPersonId)

  return {
    externalCompanyId,
    externalPersonId,
    isLoading,
    isValidPersonId:
      isLoading ||
      selectDirectorByExternalId(state, externalPersonId)?.externalId === externalPersonId,
    updatePending: selectSavePending(state),
    formData: selectInitialFormData(state, externalPersonId),
    hasError: selectSaveHasError(state),
    errorMessage: selectSaveErrorMessage(state),
    pageIsVerified:
      selectCombinedInputFieldStatusBySectionName(state, SECTION_DIRECTORS) ===
      FeInputFieldStatus.VERIFIED,
    hasAnyRoleBasedFieldsVisible: selectIsAnyRoleBasedFieldsVisible(state),
    directorName: selectDirectorNameByExternalId(state, externalPersonId),
  }
}
const mapDispatchToProps = {
  initialize: aInitializePage,
  onSubmit: aSavePage,
  onDiscard: aReset,
  redirect: aPush,
}

export default compose(
  withSuspense(false),
  connect(mapStateToProps, mapDispatchToProps)
)(ExistingDirector)
